import { defineComponent as _defineComponent } from 'vue'
import NoRecentSearchs from '@/components/ui/NoRecentSearchs.vue'
import NoResultsFound from '@/components/ui/NoResultsFound.vue'
import { ParametrosDoFind, ResultadoBusca } from '../../../common/types/Busca'
import SearchService from '@/services/SearchService'
import ItemDaBusca from './components/ItemDaBusca.vue'
import ToolbarDaBusca from './components/ToolbarDaBusca.vue'
import { computed, onBeforeUnmount, onMounted, ref, watch, nextTick } from 'vue'
import { useInfiniteQuery, useQueryClient } from '@tanstack/vue-query'
import { CamposDoFiltroDeBusca, obterFiltroDefault, OPCOES_DE_BUSCAR_EM } from '@/shareds/sharedBusca'
import { application, authModule, userModule } from '@/store'
import { useRoute, useRouter } from 'vue2-helpers/vue-router'
import { SituacaoDoMacon } from 'common/types/Irmao'
import { arraysAreEqual } from '../../../common/shareds/utils'
import { Dictionary } from 'vue-router/types/router'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'Busca',
  setup(__props) {

const temBusca = ref(true)

const route = useRoute()
const router = useRouter()

function converterParaParametrosDoFind(params: CamposDoFiltroDeBusca): ParametrosDoFind {
	return {
		search: params.busca,
		loja: params.loja ? params.loja.value : undefined,
		somar: params.minhaSomar && userModule.currentUser?.role !== 'Visitante' ? userModule.currentUser?.somar?._id : undefined,
		recentes: params.recentes,
		situacoes: Array.isArray(params.situacoes) ? params.situacoes : (params.situacoes ? [params.situacoes] : []),
		buscarEm: authModule.éVisitante
			? ['servico']
			: Array.isArray(params.buscarEm) ? params.buscarEm : (params.buscarEm ? [params.buscarEm] : undefined),
	}
}

const filtro = computed<CamposDoFiltroDeBusca>({
	get() {
		const filtroDefault = obterFiltroDefault()
		const { query } = route

		const situacoes = typeof query.situacoes === 'string' ? [query.situacoes as SituacaoDoMacon] : ((query.situacoes as (SituacaoDoMacon[] | undefined)) || filtroDefault.situacoes)
		const buscarEm = typeof query.buscarEm === 'string' ? [query.buscarEm as ResultadoBusca['resultType']] : ((query.buscarEm as (ResultadoBusca['resultType'][] | undefined)) || filtroDefault.buscarEm)

		return {
			...filtroDefault,
			...query,
			recentes: query.recentes === 'true',
			minhaSomar: query.minhaSomar !== 'false',
			loja: typeof query.loja === 'string' ? JSON.parse(query.loja) : null,
			situacoes,
			buscarEm,
		} satisfies CamposDoFiltroDeBusca
	},
	set(params: CamposDoFiltroDeBusca) {
		const filtroDefault = obterFiltroDefault()

		const query: Dictionary<string | (string | null)[] | null | undefined> = {}
		if (params.busca) {
			query.busca = params.busca
		}
		if (params.loja) {
			query.loja = JSON.stringify({ text: params.loja.text, value: params.loja.value })
		}
		if (params.buscarEm && params.buscarEm.length !== OPCOES_DE_BUSCAR_EM.length) {
			query.buscarEm = params.buscarEm
		}
		if (!arraysAreEqual(params.situacoes, filtroDefault.situacoes)) {
			query.situacoes = params.situacoes
		}
		if (!params.minhaSomar) {
			query.minhaSomar = 'false'
		}
		if (params.recentes) {
			query.recentes = 'true'
		}
		router.replace({
			query,
		}).catch((err) => {
			if (
				err.name !== 'NavigationDuplicated' &&
				!err.message.includes('Avoided redundant navigation to current location')
			) {
				console.error(err);
			}
		})
	}
})

const findParams = computed<ParametrosDoFind>(() => converterParaParametrosDoFind(filtro.value))

const queryClient = useQueryClient()

const { data: resultados, isLoading: buscando, isFetchingNextPage, fetchNextPage, hasNextPage } = useInfiniteQuery({
	queryKey: ['busca', findParams],
	queryFn: ({ pageParam }) => {
		const params = findParams.value
		return SearchService.find({ pagina: pageParam, ...findParams.value })
			.then((resultados) => {
				if (params.recentes && params?.buscarEm?.includes('servico')) {
					application.visualizar({ ultVisualizacaoDeServicos: dayjs().toISOString() })
				}
				return resultados
			})
	},
	initialPageParam: 1,
	getNextPageParam: (lastPage) => lastPage.paginacao.pagina < lastPage.totalDePaginas
		? lastPage.paginacao.pagina + 1
		: undefined,
})

const temDados = computed(() => !!resultados.value?.pages.flatMap(pagina => pagina.items).length)

async function buscar(novoFiltro: CamposDoFiltroDeBusca) {
	filtro.value = novoFiltro
	nextTick(() => {
		queryClient.invalidateQueries({
			queryKey: ['busca', findParams],
		})
	})
}

function onClickLimparBusca() {
	temBusca.value = false
}

const infiniteScrollTrigger = ref(null);
let observer!: IntersectionObserver;

watch(() => infiniteScrollTrigger.value, (current, old) => {
  if (!!current && current !== old) {
    observer.observe(current);
  }
})

onMounted(() => {
  observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting && hasNextPage.value) {
      fetchNextPage();
    }
  });

  if (infiniteScrollTrigger.value) {
    observer.observe(infiniteScrollTrigger.value);
  }
});

onBeforeUnmount(() => {
  if (observer) observer.disconnect();
});

return { __sfc: true,temBusca, route, router, converterParaParametrosDoFind, filtro, findParams, queryClient, resultados, buscando, isFetchingNextPage, fetchNextPage, hasNextPage, temDados, buscar, onClickLimparBusca, infiniteScrollTrigger, observer, NoRecentSearchs, NoResultsFound, ItemDaBusca, ToolbarDaBusca, OPCOES_DE_BUSCAR_EM, authModule }
}

})